import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pages",
  "use": "pages-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pages\"><path fill-rule=\"evenodd\" d=\"m14.011 8 5.065-.003-5.065-5.073V8Zm0-6.5L20.5 8.007V16.5c0 1.1-.889 2-1.989 2H9.49c-1.099 0-1.99-.9-1.99-2l.011-13c0-1.1.89-2 1.989-2h4.511ZM3.51 5.5h2l-.01 13c0 1.1.891 2 1.99 2h9.01v2H7.49a4 4 0 0 1-3.99-4l.01-13Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol